import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const SubscriptionIcon: React.FC<IconProps> = ({ className, ...props }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M54 12.6667H10C7.79086 12.6667 6 14.4576 6 16.6667V47.3334C6 49.5426 7.79086 51.3334 10 51.3334H54C56.2091 51.3334 58 49.5426 58 47.3334V16.6667C58 14.4576 56.2091 12.6667 54 12.6667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 22H58"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6667 46.0002V43.3335"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.6667 46.0002V43.3335"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.6667 46.0002V43.3335"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SubscriptionIcon;
